module.exports = __webpack_public_path__ + "static/img/case-kyj-page-bg-01.018fb8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/kyj/case-kyj-page-bg-01.jpg
// module id = tbUO
// module chunks = 1